import React from "react";
import { SelectedIngredient } from "../../../interfaces/Catalogue";
import { getPriceByTypeOrderForComposition } from "../../../utils/priceUtils";
import "./IngredientDetails.scss"; // Fix typo in filename if needed

interface IngredientDetailsProps {
  selectedIngredients: SelectedIngredient[];
  orderType: number;
}

const IngredientDetails: React.FC<IngredientDetailsProps> = ({ selectedIngredients, orderType }) => {
  if (!selectedIngredients || selectedIngredients.length === 0) {
    return null; // Ensure the component always returns a valid JSX element
  }

  return (
    <p className="SubitemDescription">
      {selectedIngredients.map((ingredient, index) => {
        const priceComposition = getPriceByTypeOrderForComposition(
          orderType,
          ingredient.ingredient
        );

        return (
          <span key={index}>
            {ingredient?.quantity > 1 && ingredient?.quantity}{" "}
            {ingredient?.ingredient?.name}
            {priceComposition > 0 && ` (${priceComposition * ingredient.quantity} €) `}
            {index < selectedIngredients.length - 1 ? ", " : ""}
          </span>
        );
      })}
    </p>
  );
};

export default IngredientDetails;
